import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchPublicCompanyReviews } from "./PublicCompanyReviewsAPI";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchPublicCompanyReviewsAsync = createAsyncThunk(
  "PublicCompanyReviews/fetch",
  async ({uuid}, { rejectWithValue }) => {
    try {
      const data = await fetchPublicCompanyReviews(uuid);

      const resp = data.response.data;
      // console.log("data's response", data.response.data)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PublicCompanyReviewsSlice = createSlice({
  name: "PublicCompanyReviews",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicCompanyReviewsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPublicCompanyReviewsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchPublicCompanyReviewsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
  },
});

export const selectPublicCompanyReviews = (state) => state.publicCompanyReviews.data;

export default PublicCompanyReviewsSlice.reducer;
